import React from 'react'
import styles from '../../tabs/review/GetReviews/GetReviews.module.scss'
import ReviewsListItem from './ReviewsListItem'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'

function ReviewsList({ reviews, handleScroll, loading }) {
  return (
    <div onScroll={handleScroll} className={styles.reviewCardsContainer}>
      <div className={styles.masonryWrapper}>
        <ResponsiveMasonry columnsCountBreakPoints={{ 0: 1, 1200: 2 }}>
          <Masonry gutter='var(--masonry-gutter)'>
            {reviews.map((item, index) => (
              <ReviewsListItem data={item} key={index} isFirst={index === 0} />
            ))}
            {loading && reviews.length > 0 && (
              <>
                <div className={styles.reviewSkeletonItem}>
                  <div className={styles.reviewSkeletonHeader}>
                    <div className={styles.reviewSkeletonPhoto} />
                    <div className={styles.reviewSkeletonInfo}>
                      <div className={styles.reviewSkeletonName} />
                      <div className={styles.reviewSkeletonRank} />
                      <div className={styles.reviewSkeletonVessel} />
                      <div className={styles.reviewSkeletonDate} />
                    </div>
                  </div>
                </div>
                <div className={styles.reviewSkeletonItem}>
                  <div className={styles.reviewSkeletonHeader}>
                    <div className={styles.reviewSkeletonPhoto} />
                    <div className={styles.reviewSkeletonInfo}>
                      <div className={styles.reviewSkeletonName} />
                      <div className={styles.reviewSkeletonRank} />
                      <div className={styles.reviewSkeletonVessel} />
                      <div className={styles.reviewSkeletonDate} />
                    </div>
                  </div>
                </div>
              </>
            )}
          </Masonry>
        </ResponsiveMasonry>
      </div>
    </div>
  )
}

export default ReviewsList
